import React from 'react'
import LeaveAllotment from '../Components/LeaveManagement/LeaveAllotment'

const LeaveManagementPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <LeaveAllotment/>
    </div>
  )
}

export default LeaveManagementPage
